import { big, ZERO } from '@swarm/core/shared/utils/helpers/big-helpers'
import { ExtendedSecurity } from '@swarm/types/normalized-entities'
import { BigSource } from 'big.js'
import { differenceInCalendarDays, fromUnixTime } from 'date-fns'

import { StakeStatus, WarmupPeriodInDays } from './consts'

export const calcStakedSecuritySMT = (security: ExtendedSecurity) => {
  if (!security.stakes) return ZERO
  return security.stakes.reduce((sum, stake) => {
    if (!stake.unstaked) {
      return sum.plus(stake.stakedAmount)
    }
    return sum
  }, big(0))
}

export const calcAPY = (smtReward: BigSource, totalStakedSmt: BigSource) => {
  const factor = big(smtReward).div(totalStakedSmt)
  const annualEstimate = 52
  const percent = 100
  const apy = factor.mul(annualEstimate).mul(percent)
  return apy
}

export const getStakeStatusInfo = (timestamp: number) => {
  const stakedAt = fromUnixTime(timestamp)
  const now = new Date()

  const daysDifference = differenceInCalendarDays(now, stakedAt)

  if (daysDifference < WarmupPeriodInDays) {
    const daysLeft = WarmupPeriodInDays - daysDifference

    return {
      status: StakeStatus.warmup,
      days: daysLeft,
    }
  }

  const daysEarning = daysDifference - WarmupPeriodInDays
  return {
    status: StakeStatus.earning,
    days: daysEarning,
  }
}
